import { EBlotterTab } from '../../enums';
import { filter, takeUntil } from 'rxjs/operators';
import { GRID_ACTION_SERVICE, IGridActionService } from '../grid-action';
import { IDetailsViewInfo, IGridDataRow } from '../../interfaces';
import { IDetailsViewService } from './details-view.interface';
import { inject, injectable } from 'inversify';
import { ISelectedClientService, SELECTED_CLIENT_SERVICE } from '../../services/selected-client';
import { Observable, Subject } from 'rxjs';

@injectable()
export class DetailsViewService implements IDetailsViewService {
    @inject(GRID_ACTION_SERVICE) private readonly gridActionSrv: IGridActionService;
    @inject(SELECTED_CLIENT_SERVICE) private readonly selectedClientSrv: ISelectedClientService;

    private readonly destroyed$ = new Subject<boolean>();

    private detailsViewInfo$: Subject<IDetailsViewInfo>;

    private blotterType: EBlotterTab;
    private orderList: Array<IGridDataRow> = [];

    asObservable(): Observable<IDetailsViewInfo> {
        if (!Boolean(this.detailsViewInfo$)) {
            this.init();
        }
        return this.detailsViewInfo$.asObservable();
    }

    updateOrderList(orderList: Array<IGridDataRow>): void {
        this.orderList = orderList;
        this.nofify();
    }

    private init(): void {
        this.detailsViewInfo$ = new Subject<IDetailsViewInfo>();

        this.gridActionSrv.asObservable().pipe(
            filter(({ action }) => action === 'viewDetails'),
            takeUntil(this.destroyed$),
        ).subscribe(({ gridType, dataItem }) => {
            if (this.blotterType !== gridType) {
                this.orderList = [ dataItem ];
            } else {
                this.orderList.unshift(dataItem);
            }
            this.blotterType = gridType;

            this.nofify();
        });

        this.selectedClientSrv.asObservable().pipe(
            takeUntil(this.destroyed$),
        ).subscribe(() => {
            this.orderList = [];
            this.nofify();
        });
    }

    private nofify(): void {
        this.detailsViewInfo$.next({
            blotterType: this.blotterType,
            orderList: [ ...this.orderList ],
        });
    }

    protected stop(): void {
        this.destroyed$.next(true);
    }
}
